import { render, staticRenderFns } from "./Form1.vue?vue&type=template&id=6009b456&scoped=true"
import script from "./Form1.vue?vue&type=script&lang=ts"
export * from "./Form1.vue?vue&type=script&lang=ts"
import style0 from "./Form1.vue?vue&type=style&index=0&id=6009b456&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6009b456",
  null
  
)

export default component.exports